export enum StatusCode {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,

  INTERNAL_SERVER_ERROR = 500,
}
